import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import Modal from '@ui-library/modal/skeleton';
import Button from '@ui-library/button';
import classes from './error.module.scss';
import CopyToClipboard from '@ui-library/copyToClipboard';

interface Props {
  header: string;
  subHeader: string;
  onClose: () => void;
  view: JSX.Element;
  handleBackClick?: () => void;
  showBackButton: boolean;
  clipboardContent?: string;
}

export default ({
  header,
  subHeader,
  onClose,
  view,
  handleBackClick,
  showBackButton,
  clipboardContent,
}: Props) => (
  <Modal show modalClosed={onClose}>
    <div className={classes.error_modal} onClick={(e) => e.stopPropagation()}>
      <div className={classes.header}>
        <div className={classes.header_info}>
          <div className={classes.main_text} data-testid="header">
            {header}
          </div>
          <div className={classes.sub_text} data-testid="subHeader">
            {subHeader}
          </div>
        </div>
        {!!clipboardContent && (
          <div style={{ marginLeft: 'auto', marginRight: '1rem' }} data-testid="clipboard">
            <CopyToClipboard content={clipboardContent} />
          </div>
        )}
        <Button textSecondary shape="circle" onClick={onClose} data-testid="btnCloseIcon">
          <CloseOutlined />
        </Button>
      </div>
      <div className={classes.body}>{view}</div>
      <div className={classes.footer}>
        <Button type="primary" onClick={onClose} name="Close" data-testid="btnClose" />
        {showBackButton && (
          <Button type="default" onClick={handleBackClick} name="Back" data-testid="btnBack" />
        )}
      </div>
    </div>
  </Modal>
);
